import React from 'react';
import RelativeRiskTable from './subComponents/RelativeRiskTable.component';
import RelativeRiskChart from './subComponents/RelativeRiskChart.component';
import { FundInfoComponentProps } from '../../../layout/general/SimpleGeneralPageWrapper';
import { QueryBoundary } from '../../../utilityComponents/QueryBoundary';
import { useRelativeRiskPageQuery } from '../../../../api/rs-hg/risk/hooks/queries';
import type { RelativeRiskPayload } from '../../../../api/rs-hg/risk/relativeRisk.types';

const RelativeRisk: React.FC<FundInfoComponentProps> = ({
  positionDate,
  fundId,
}) => {
  const isPositionDateLoading = !!fundId && !positionDate;
  const relativeRiskQuery = useRelativeRiskPageQuery(fundId, positionDate);

  return (
    <QueryBoundary<RelativeRiskPayload>
      isLoading={isPositionDateLoading || relativeRiskQuery.isLoading}
      isFetching={relativeRiskQuery.isFetching}
      isError={relativeRiskQuery.isError}
      error={relativeRiskQuery.error}
      data={relativeRiskQuery.data?.data}
      loadingMessages={
        isPositionDateLoading
          ? ['Loading position date...']
          : ['Loading Relative Value At Risk Data...']
      }
      noDataMessage="No Data Available."
      errorMessage="No Data Available."
    >
      {(pageData) => (
        <>
          <RelativeRiskChart data={pageData} />
          <RelativeRiskTable data={pageData} />
        </>
      )}
    </QueryBoundary>
  );
};

export default RelativeRisk;
